import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  statusActive: {
    color: theme.palette.success.main,
  },
  statusCell: {
    alignItems: 'center',
    display: 'flex',
  },
  statusDisabled: {
    color: theme.palette.error.main,
  },
  statusInvited: {
    color: theme.palette.info.main,
  },
}));

const UserStatusCell = ({ status }) => {
  const classes = useStyles();

  let statusClass = '';

  if (status === 'Active') statusClass = classes.statusActive;
  else if (status === 'Disabled') statusClass = classes.statusDisabled;
  else if (status === 'Invited') statusClass = classes.statusInvited;

  return (
    <div className={classes.statusCell}>
      <span className={statusClass}>{status}</span>
    </div>
  );
};

export default UserStatusCell;
